import React from 'react';
import { Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';

import redalameda from 'src/recursos/redalameda.png';

export interface Props {
    cargando: boolean;
    mensajeDeError?: string;
    usuario: string;
    contraseña: string;
    alCambiarTextos(campos: { usuario: string; contraseña: string }): void;
    alPresionarBoton(): void;
}

const LoginForm: React.FunctionComponent<Props> = props => {
    const {
        cargando,
        mensajeDeError,
        usuario,
        contraseña,
        alCambiarTextos,
        alPresionarBoton,
    } = props;

    const error = !!mensajeDeError;

    return (
        <div style={{ height: '100vh' }}>
            <Grid textAlign='center' verticalAlign='middle' style={{ height: '100%' }}>
                <Grid.Column style={{ maxWidth: '400px' }}>
                    <Form size='large' onSubmit={alPresionarBoton} error={error}>
                        <Header as='h1' color='green'>
                            <Image src={redalameda} />
                            Intranet Red Alameda
                        </Header>

                        <Segment stacked raised>
                            <Form.Input
                                icon='user'
                                iconPosition='left'
                                placeholder='Nombre de usuario'
                                type='text'
                                autoComplete='username'
                                autoFocus
                                fluid
                                disabled={cargando}
                                error={error}
                                value={usuario}
                                onChange={(_e, { value }) => {
                                    alCambiarTextos({ usuario: value, contraseña });
                                }}
                            />
                            <Form.Input
                                icon='lock'
                                iconPosition='left'
                                placeholder='Contraseña'
                                type='password'
                                autoComplete='current-password'
                                fluid
                                disabled={cargando}
                                error={error}
                                value={contraseña}
                                onChange={(_e, { value }) => {
                                    alCambiarTextos({ usuario, contraseña: value });
                                }}
                            />

                            <Form.Button
                                fluid
                                color='blue'
                                size='large'
                                icon='sign in'
                                loading={cargando}
                                content='Iniciar sesión'
                            />
                        </Segment>

                        <Message style={{ textAlign: 'left' }} error content={mensajeDeError} />
                    </Form>
                </Grid.Column>
            </Grid>
        </div>
    );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/paginas/Login/componentes/LoginForm.tsx